// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Correct from '../_raw/ui/icon_correct.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Correct);
